import { cn } from '@/lib/utils'
import { SpinnerIosRegular } from '@fluentui/react-icons'

interface LoadingComponentProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  icon?: React.ReactNode
}

export const LoadingComponent = ({ text = 'Loading page...', icon, className, ...props }: LoadingComponentProps) => (
  <div className={cn('bg-offwhite col-span-full flex size-full items-center justify-center', className)} {...props}>
    <div className="flex flex-col items-center gap-y-10">
      {icon && <div className="text-muted-foreground">{icon}</div>}
      <div className="flex w-max items-center gap-x-2">
        <SpinnerIosRegular fontSize={20} className="animate-spin" />
        <span>{text}</span>
      </div>
    </div>
  </div>
)
